import React from "react";
import "./Profile.scss";
import profileImage from "../assets/profile.jpg";
import useInView from "../hooks/useInView";

const ROWS = [
  { label: "이름", value: "윤성빈" },
  { label: "생년월일", value: "2000.07.13" },
  {
    label: "이메일",
    value: "dbstjdqls14@naver.com",
    link: "mailto:dbstjdqls14@naver.com",
  },
  { label: "전화번호", value: "010-5033-4307", link: "tel:010-5033-4307" },
  {
    label: "학력",
    value: "서일대학교 소프트웨어학과 졸업 (학점 4.49 / 4.5, 수석 졸업)",
  },
  {
    label: "Github",
    value: "github.com/dbstjdqls14",
    link: "https://github.com/dbstjdqls14",
  },
  {
    label: "블로그",
    value: "udangtang-dev.tistory.com",
    link: "https://udangtang-dev.tistory.com",
  },
];

function Profile() {
  const [ref, inView] = useInView();

  return (
    <section className="section profile" id="profile" ref={ref}>
      <div className="container">
        <h2 className={`section-title reveal ${inView ? "is-in" : ""}`}>
          Profile
        </h2>

        <div className="profile-grid">
          <figure
            className={`profile-photo reveal ${inView ? "is-in" : ""}`}
            style={{ "--delay": "90ms" }}
          >
            <img src={profileImage} alt="윤성빈 프로필 사진" />
          </figure>

          <dl
            className={`profile-rows reveal ${inView ? "is-in" : ""}`}
            style={{ "--delay": "160ms" }}
          >
            {ROWS.map((row) => {
              const external = row.link && row.link.startsWith("http");

              return (
                <div className="profile-row" key={row.label}>
                  <dt>{row.label}</dt>
                  <dd>
                    {row.link ? (
                      <a
                        href={row.link}
                        target={external ? "_blank" : undefined}
                        rel={external ? "noopener noreferrer" : undefined}
                      >
                        {row.value}
                      </a>
                    ) : (
                      row.value
                    )}
                  </dd>
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}

export default Profile;
